module.exports = __webpack_public_path__ + "img/video-y-fotografia-subacuatica_poster.8fc08950.jpg";